import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { Lien } from "pages/liens/LienTypes";

interface LiensState {
  showAddPartModal: boolean;
  showCreateLienModal: boolean;
  liens: Lien[];
  currentLienStatus: {
    analysis_complete: boolean;
    client_submission: boolean;
    case_closed: boolean;
  } | null;
}

const initialState: LiensState = {
  showAddPartModal: false,
  showCreateLienModal: false,
  liens: [],
  currentLienStatus: null,
};

const liensSlice = createSlice({
  name: "liens",
  initialState,
  reducers: {
    setShowAddPartModal: (state, action: PayloadAction<boolean>) => {
      state.showAddPartModal = action.payload;
    },
    setShowCreateLienModal: (state, action: PayloadAction<boolean>) => {
      state.showCreateLienModal = action.payload;
    },
    setLiens: (state, action: PayloadAction<Lien[]>) => {
      state.liens = action.payload;
    },
    setCurrentLienStatus: (
      state,
      action: PayloadAction<{
        analysis_complete: boolean;
        client_submission: boolean;
        case_closed: boolean;
      } | null>,
    ) => {
      state.currentLienStatus = action.payload;
    },
    updateLienStatus: (
      state,
      action: PayloadAction<{
        field: "analysis_complete" | "client_submission" | "case_closed";
        value: boolean;
      }>,
    ) => {
      if (state.currentLienStatus) {
        state.currentLienStatus[action.payload.field] = action.payload.value;
      }
    },
  },
});

export const {
  setShowAddPartModal,
  setShowCreateLienModal,
  setLiens,
  setCurrentLienStatus,
  updateLienStatus,
} = liensSlice.actions;
export default liensSlice.reducer;
